import { render, staticRenderFns } from "./DropdownToggle.vue?vue&type=template&id=23b744bc&"
import script from "./DropdownToggle.vue?vue&type=script&lang=js&"
export * from "./DropdownToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports